import { useStageName } from '../../../utils/hooks';

type Props = {
  status: string;
};

export const StatusColumn = ({ status }: Props) => {
  return <>{useStageName(status)}</>;
};
